var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticStyle: { height: "6%" }, attrs: { "align-center": "" } },
    [
      _c("user-avatar", {
        staticClass: "ml-1 mr-1",
        attrs: { height: "45px", width: "45px" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "user-name" }, [
        _vm._v(" " + _vm._s(_vm.userName))
      ]),
      _vm._v(" "),
      _c("activate-two-authentication-dialog", {
        attrs: { open: _vm.opened2FArequired },
        on: {
          close: function($event) {
            _vm.opened2FArequired = false
          },
          activateAuthenticate: function($event) {
            _vm.twoFactorAuthentication = true
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b748e44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b748e44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/LeftSidebar/UserInfo.vue
// module id = null
// module chunks = 